import React, { useEffect } from "react";
// import bmp from "assets/img/newBMP.png";
// import bmp from "assets/img/newBMP.jpeg";
import "./index.css";
import { usePag } from "containers/pagProvider";
// import tourist from "../../assets/mp4/tourist.mp4";

export default function BottomContent({
  showHomePage,
  setShowClickArea,
  setDirectShowMap,
  setDestoryTransition,
}) {
  // useEffect(() => {
  //   const cloudBox = document.querySelector("#cloud");
  //   let clickAreaTimer;
  //   let timeOut;
  //   setShowClickArea(true);
  //   if (cloudBox) {
  // document.querySelector("#transitionImg").style.display = "none";
  // cloudBox.classList.add("cloudBox");
  // const cloudMask = document.querySelector(".cloudMask");
  // cloudMask.classList.add("cloudMaskout");
  // clickAreaTimer = setTimeout(() => {
  //   setShowClickArea(true);
  //   clearTimeout(clickAreaTimer);
  // }, 1000);
  // timeOut = setTimeout(() => {
  //   cloudBox.style.display = "none";
  //   clearTimeout(timeOut);
  // }, 2000);
  // }

  // return () => {
  // clickAreaTimer && clearTimeout(clickAreaTimer);
  // timeOut && clearTimeout(timeOut);
  // };
  // }, [showHomePage]);

  const { pag, touristMapPag, pagFail } = usePag();

  useEffect(() => {
    async function generateBg() {
      try {
        // const pagFile = await pag.PAGFile.load(touristMapPag);
        const pagFile = touristMapPag;
        const canvas = document.getElementById("touristMap");
        // canvas.width = pagFile.width();
        // canvas.height = pagFile.height();
        canvas.width = 414;
        canvas.height = 2974;
        // console.log(canvas.height, pagFile.height());
        // 实例化 PAGView 对象
        const pagView = await pag.PAGView.init(pagFile, canvas, {
          useScale: false,
          firstFrame: false,
        });
        // 播放 PAGView
        pagView.setRepeatCount(0);
        // pagView.setScaleMode(2);
        // const matrix = new pag.Matrix();
        // const originMatrix = pagView.matrix();

        // const ty = originMatrix.ty;
        // Object.assign(originMatrix, { ty: 0 });
        // canvas.height = pagFile.height() - ty;

        // pagFile.setMatrix(originMatrix);
        pagView.play();
        setShowClickArea(true);
        // setDirectShowMap(true);
        setDestoryTransition(true);
      } catch (er) {
        console.log("tourist try catch error: ", er);
        setShowClickArea(true);
        setDestoryTransition(true);
      }
    }

    if (pag && touristMapPag) {
      generateBg();
    } else if (pagFail) {
      // const video = document.querySelector("#touristVideo");
      // const canvas = document.getElementById("touristMap");
      // canvas.style.display = "none";
      // video.style.display = "block";
      // video.load();
      // setTimeout(() => {
      //   video.play();
      // }, 100);
      setShowClickArea(true);
      setDestoryTransition(true);
    }
  }, [pag, touristMapPag, setShowClickArea, setDestoryTransition, pagFail]);

  return (
    <div className="bottom-content">
      <canvas id="touristMap"></canvas>
      {/* <video preload="auto" playsInline id="touristVideo" loop>
        <source src={tourist} />
      </video> */}
      {/* <img
        src={bmp}
        // loading="lazy"
        // src="https://gimg2.gateimg.com/yearreport2023/170019180373810907newBMP.jpeg"
        className="bottom-content-img"
        alt=""
      /> */}
    </div>
  );
}
